import { render, staticRenderFns } from "./shopabout.vue?vue&type=template&id=e9bc44f4&scoped=true"
import script from "./shopabout.vue?vue&type=script&lang=js"
export * from "./shopabout.vue?vue&type=script&lang=js"
import style0 from "./shopabout.vue?vue&type=style&index=0&id=e9bc44f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bc44f4",
  null
  
)

export default component.exports